import { useEffect, useState } from 'react';
import { buildPanelViewModel } from '../utils/whatVervestacks/buildPanelViewModel';
import { loadWhatVervestacksYaml } from '../utils/whatVervestacksYamlLoader';

const EMPTY_VIEW_MODEL = {
  frameworkBlocks: [],
  sections: [],
  countries: null,
  cta: null,
  presentation: null,
};

export function useWhatVervestacksContent(country) {
  const [state, setState] = useState({
    loading: true,
    error: null,
    panel: null,
    displayName: '',
    source: null,
    yamlFile: null,
    viewModel: EMPTY_VIEW_MODEL,
  });

  const isoCode = country?.iso_code;

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      if (!isoCode) {
        setState({
          loading: false,
          error: 'Country is not available',
          panel: null,
          displayName: '',
          source: null,
          yamlFile: null,
          viewModel: EMPTY_VIEW_MODEL,
        });
        return;
      }

      setState((prev) => ({ ...prev, loading: true, error: null }));

      try {
        const result = await loadWhatVervestacksYaml(isoCode, country?.name);
        if (cancelled) return;

        const viewModel = buildPanelViewModel(
          result.panel,
          result.source,
          result.displayName
        );

        setState({
          loading: false,
          error: null,
          panel: result.panel,
          displayName: result.displayName,
          source: result.source,
          yamlFile: result.yamlFile,
          viewModel,
        });
      } catch (err) {
        if (cancelled) return;
        setState({
          loading: false,
          error: err?.message || 'Failed to load What VerveStacks content',
          panel: null,
          displayName: country?.name || '',
          source: null,
          yamlFile: null,
          viewModel: EMPTY_VIEW_MODEL,
        });
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [isoCode, country?.name]);

  return state;
}
